The minimum amount an organization is willing to pay for a position.

The value must be greater than 0.
